export default __webpack_public_path__ + "static/media/Asthma.f08e1932.png";